// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const Ayucoxib = {
  productCode: "SBOVZ-ACX",
  productName: "Ayucoxib-10",
  ingredients: "Tribulus terrestris, Boswellia serrata, Bromelain, Piper longum, Resveratrol",
  overview:"Botanical and whole food Anti Inflammatory Supplement",
  assay:"Vitamin C: 32 mg; Vitamin D3: 300 IU; Tribulus terrestris extract: 25 mg; Boswellia serrata: 50 mg; Bromelain, Piper longum extract: 7.5 mg; Resveratrol: 30 mg; Curcuminoids: 100 mg",
  coNutrients:"Saponins, Piperine, Polyphenols, Gingerols and Proanthocyanidins work on various inflammatory pathway.",
  studies:"",
  benefits:"Inflammatory gene products activated by nuclear factors are responsible for wide variety of diseases including cancer, cardiovascular and arthritis. Ayucoxib is a combination of herbal actives that work on various molecular targets of inflammatory pathway.",
  functionalUse: {
    main: "💊︎ Capsule",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForConditions/Ayucoxib-10.png"
    

  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",

  ]
};

export default Ayucoxib;
